import React, { Component } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Help from "../Component/Help";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const Box = styled.div`
  width: 60%;
  max-width: 400px;
  display: flex;
  justify-content: center;
`;

const Button = styled(Link)`
  padding: 10px 20px;
  margin: 0px 5px;
  border-radius: 15px;
  font-size: 14px;
  background-color: rgba(24, 12, 12, 1);
  color: white;

  &:hover {
    background-color: white;
    color: rgba(24, 12, 12, 1);
    transition: 0.3s ease-in-out;
    /* box-shadow: 0px 0px 15px 0px rgba(24, 12, 12, 1); */
  }
`;

class Buttons extends Component {
  render() {
    const { array } = this.props;
    return (
      <Container>
        <Box>
          {array.map((button, index) =>
            button[0] === "info" ? (
              <Help key={index} value={button[1]}></Help>
            ) : (
              <Button
                onClick={button[2]}
                className="disableDrag"
                to={button[1]}
                key={index}
                id={button[3] ? "saveBtn" : ""}
              >
                {button[0]}
              </Button>
            )
          )}
        </Box>
      </Container>
    );
  }
}

export default Buttons;
